// extracted by mini-css-extract-plugin
export var sliderRange = "_ms-2";
export var sliderRoot = "_ms-0";
export var sliderThumb = "_ms-3";
export var sliderTrack = "_ms-1";